import { type ComponentProps, forwardRef } from 'react';

import { cn } from '@air/utils-tailwind';

import { BOARD_PAGE_TABLE_HEADER } from '~/constants/testIDs';

export type TableHeaderProps = Pick<ComponentProps<'div'>, 'children' | 'className' | 'style'> & {
  innerStyle?: ComponentProps<'div'>['style'];
};

const TableHeader = forwardRef<HTMLDivElement, TableHeaderProps>(
  ({ children, className, style, innerStyle, ...restOfProps }, ref) => {
    return (
      <div
        className={cn(
          'ios-safari-fixed-element-hack sticky z-1 flex min-h-[48px] items-center overflow-hidden border-b ads:border-b-default border-b-gray-4 ads:bg-base bg-gray-1 font-semibold ads:text-metadata text-12 text-gray-9 transition-all',
          '[&_.table-cell]:flex [&_.table-cell]:min-h-[48px] [&_.table-cell]:py-0',
          className,
        )}
        {...restOfProps}
        ref={ref}
        data-testid={BOARD_PAGE_TABLE_HEADER}
        style={style}
      >
        <div className="flex w-full items-center" style={innerStyle}>
          {children}
        </div>
      </div>
    );
  },
);

TableHeader.displayName = 'BoardPageTableHeader';

export default TableHeader;
